import { defineMessages } from 'react-intl';

export default defineMessages({
  branchKindLozengeMain: {
    id: 'frontbucket.branches.branchKindLozenge.main',
    description: 'Branch kind lozenge label for main branch',
    defaultMessage: 'main',
  },
  branchKindLozengeDevelopment: {
    id: 'frontbucket.branches.branchKindLozenge.development',
    description: 'Branch kind lozenge label for development branch',
    defaultMessage: 'development',
  },
  branchKindLozengeProduction: {
    id: 'frontbucket.branches.branchKindLozenge.production',
    description: 'Branch kind lozenge label for production branch',
    defaultMessage: 'production',
  },
  branchKindLozengeStale: {
    id: 'frontbucket.branches.branchKindLozenge.stale',
    description: 'Branch kind lozenge label for stale branch',
    defaultMessage: 'stale',
  },
});
